module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/online_sp-8ca0dc04c8d1c5f279a5e872680f0ef4.png";